Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressIndicator = exports.CircularProgress = void 0;
var ProgressIndicator_1 = require("./ProgressIndicator");
Object.defineProperty(exports, "CircularProgress", { enumerable: true, get: function () { return ProgressIndicator_1.CircularProgress; } });
Object.defineProperty(exports, "ProgressIndicator", { enumerable: true, get: function () { return ProgressIndicator_1.ProgressIndicator; } });
exports.default = ProgressIndicator_1.ProgressIndicator;
//# sourceMappingURL=index.js.map